import { ReactElement } from 'react';
import cx from 'classnames';
import Tooltip, { TooltipDirection } from 'lib/Tooltip';
import { getFilenameParts } from 'utils/fileUtils';

const MAX_FILENAME_LENGTH = 16;
const TRUNCATED_FILENAME_WIDTH_CLASS = 'w-[100px]';

const getFilenameWidthClass = (shouldTruncateFilename: boolean): string =>
  shouldTruncateFilename ? TRUNCATED_FILENAME_WIDTH_CLASS : 'w-auto';

export const renderFilename = (file: string, shouldTruncateFilename = true): ReactElement => {
  const { filename, extension } = getFilenameParts(file);
  const isFilenameTooLong = filename.trim().length >= MAX_FILENAME_LENGTH;
  const widthClass = getFilenameWidthClass(shouldTruncateFilename);

  return (
    <Tooltip tooltip={isFilenameTooLong ? file : undefined} direction={TooltipDirection.BOTTOM}>
      <div className={cx('text-neutral-900 flex', widthClass)}>
        {isFilenameTooLong ? (
          <>
            <span className={cx('block whitespace-nowrap overflow-hidden text-ellipsis', widthClass)}>{filename}</span>
            <span className="block">.{extension}</span>
          </>
        ) : (
          <span className={cx('block whitespace-nowrap overflow-hidden text-ellipsis', widthClass)}>{file}</span>
        )}
      </div>
    </Tooltip>
  );
};
